import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index'
import List from '@/components/List'
import NewIncident from '@/components/NewIncident'
import IncidentEdit from '@/components/IncidentEdit'
import IncidentDetails from '@/components/IncidentDetails'
import Report from '@/components/Report'

import store from '@/store'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/list/:component',
            name: 'List',
            component: List,
        },
        {
            path: '/new',
            name: 'NewIncident',
            component: NewIncident,
            beforeEnter: (to, from, next) => {
                store.dispatch('getUser', localStorage.getItem('id_token')).then((response) => {
                    next()
                }, (error) => {
                    console.error(error)
                    next('/')
                })
            }
        },
        {
            path: '/saturday',
            name: 'SaturdayDeploy',
            component: NewIncident,
            props: {
                type: 'saturday'
            },
            beforeEnter: (to, from, next) => {
                store.dispatch('getUser', localStorage.getItem('id_token')).then((response) => {
                    next()
                }, (error) => {
                    console.error(error)
                    next('/')
                })
            }
        },
        {
            path: '/incidents/:id',
            name: 'IncidentDetails',
            component: IncidentDetails,
        },
        {
            path: '/incidents/:id/edit',
            name: 'IncidentEdit',
            component: IncidentEdit,
            beforeEnter: (to, from, next) => {
                store.dispatch('getUser', localStorage.getItem('id_token')).then((response) => {
                    next()
                }, (error) => {
                    console.error(error)
                    next('/')
                })
            }
        },
        {
            path: '/report',
            name: 'Report',
            component: Report
        },
        {
            path: '*',
            redirect: { name: 'Index' }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js